import { UiUtilities } from '@yiluhub/ui-sdk-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { PageHeading } from 'components';
import { SummaryLayout } from 'components/Layout';
import { LoadingPageAnimation } from 'components/LoadingPageAnimation';
import ProgressBar from 'components/ProgressBar';
import { TravellerInformationForm } from 'components/TravellerInformationForm';

import { EurailProductSummary } from '../../components/EurailProductSummary';
import { useTravellerInputPage } from './hooks';
import './styles.scss';

const TravellerInputPage: React.FC = () => {
  const { isPageReady, travellerInformationFormProps, productSummaryProps, backLinkProps } =
    useTravellerInputPage();
  const { t } = useTranslation();
  const isDesktop = UiUtilities.useMediaMatch('--viewport-l');

  return (
    <div className="eurail-tip">
      {isPageReady ? (
        <div className="form-container-wrapper">
          <div className="form-container container">
            <div className="content">
              <ProgressBar srpOnClick={backLinkProps?.onClick} />
              {productSummaryProps && !isDesktop && (
                <EurailProductSummary {...productSummaryProps} />
              )}
              <PageHeading text={t('Header - Personal Info')} />
              {travellerInformationFormProps && (
                <TravellerInformationForm {...travellerInformationFormProps} />
              )}
            </div>
            {productSummaryProps && isDesktop && (
              <SummaryLayout>
                <EurailProductSummary {...productSummaryProps} />
              </SummaryLayout>
            )}
          </div>
        </div>
      ) : (
        <LoadingPageAnimation />
      )}
    </div>
  );
};

export default TravellerInputPage;
